export default "__VITE_ASSET__I6nE0Zls__"